import {RepositoryFactory} from '@/repository/RepositoryFactory';

const TasksRepository = RepositoryFactory.get('tasks');

export default {
  state: {
    tasks: [],
  },
  mutations: {
    SET_TASKS: (state, data) => {
      state.tasks = data
    },
    DELETE_TASK: (state, id) => {
      state.tasks = state.tasks.filter((x) => x.id !== id)
    },
  },
  getters: {
    tasks: state => state.tasks,
  },
  actions: {
    async fetchTasks({commit}) {
      const { data } = (await TasksRepository.getTasks()).data
      commit('SET_TASKS', data );
    },
    async createTask({commit, dispatch}, payload) {
      await TasksRepository.createTask(payload)
      dispatch('fetchTasks')
    },
    async deleteTask({commit, dispatch}, id) {
      commit('DELETE_TASK', id);

      await TasksRepository.deleteTask(id);
      dispatch('fetchTasks');
    },
    async updateTask({commit, dispatch}, {id, payload}) {
      await TasksRepository.updateTask(id, payload)
      dispatch('fetchTasks')
    },
    async changeTaskStatus({commit, dispatch}, {id, status}) {
      await TasksRepository.statusChange(id, status)
      dispatch('fetchTasks')
    },
  }
}
